import { _ as ee, a as W } from "./index-ebdb31f7.js";
import { _ as be } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.filter-4e9c9996.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.map-d821aaf5.js";
import "./es.function.name-b230e7d4.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.keys-9d66766f.js";
import "./es.object.to-string-f55666a8.js";
import "./web.set-timeout-72b6430f.js";
import { c as Q } from "./index-8b07dec9.js";
import Y, { useRef as se, useMemo as de, useContext as he, useState as re, useEffect as pe, useCallback as We } from "react";
import G, { css as V } from "styled-components";
import { BREAKPOINTS as Ze } from "@ucl/shared-component-foundations";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as ye } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { IconButton as ce } from "./iconButton.js";
import { Label as Se } from "./label.js";
import { ProgressBar as ze } from "./progressBar.js";
import { ScreenReaderOnly as Fe } from "./screenReaderOnly.js";
import "./es.number.to-fixed-2c921bf4.js";
import "./es.parse-int-d7709701.js";
import { uniqueId as ge } from "./uniqueId.js";
import { jsx as $, jsxs as te, Fragment as Ke } from "react/jsx-runtime";
import "./es.array.from-fe752fa6.js";
import "./es.string.iterator-5de8a61e.js";
import { getAriaProps as Oe } from "./aria.js";
import { g as Le } from "./getMetrics-953aa4f8.js";
import { useWindowSize as Ae } from "./useWindowSize.js";
import { Button as Qe } from "./button.js";
import { a as Ge } from "./index-5d0f31c6.js";
import { InLineAlert as Ve } from "./inLineAlert.js";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./array-method-is-strict-e5a3c878.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./combineRefs-c9ad2c39.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./string-html-forced-a746405b.js";
import "./tooltip.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./string-trim-14e37ad3.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./inherit-if-required-f068457b.js";
import "./es.regexp.to-string-e800d529.js";
import "./set-species-5ede2ed0.js";
import "./es.string.trim-6e13db75.js";
import "./carousel.js";
import "./useMediaQuery.js";
import "./helperText.js";
import "./index-f5b44da3.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.date.to-string-6ed49878.js";
import "@ucl/ucl-translation";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./index-f2264f1e.js";
import "./accessibility.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./es.global-this-a7f40ce1.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./this-number-value-32e86ff7.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./an-instance-6efcfd6c.js";
import "@ucl/shared-icons";
import "@ucl/shared-component-foundations/themeProvider";
import "@ucl/shared-component-foundations/themes";
var Je = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], Ye = function(e) {
  for (var d = 0, h = parseInt(e, 10) || 0; h >= 1e3 && ++d; )
    h = h / 1e3;
  return h.toFixed(h < 10 && d > 0 ? 2 : 1) + " " + Je[d];
}, E = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  PROGRESS: "PROGRESS",
  QUEUED: "QUEUED",
  IDLE: "IDLE"
}, ve = /* @__PURE__ */ Y.createContext({}), Ca = function(e) {
  var d = e.children, h = Y.useState({}), w = h[0], D = h[1], c = se({}), b = se({}), F = function(l, L) {
    if (c.current) {
      if (!c.current[l])
        return;
      c.current[l](L);
    }
  }, H = function(l, L) {
    c.current && (c.current[l] || (c.current[l] = L));
  }, O = function(l) {
    if (c.current) {
      if (!c.current[l])
        return;
      c.current[l]({}, !0);
    }
  }, R = function(l) {
    if (c.current) {
      if (!c.current[l])
        return;
      c.current[l] = null, delete c.current[l];
    }
  }, q = function(l, L) {
    b.current && (b.current[l] || (b.current[l] = L));
  }, A = function(l) {
    if (b.current) {
      if (!b.current[l])
        return;
      b.current[l] = null, delete b.current[l];
    }
  }, K = function(l) {
    if (b.current)
      return b.current[l] ? b.current[l] : null;
  }, P = de(function() {
    return {
      fileDispatch: F,
      fileSubscribe: H,
      fileUnsubscribe: R,
      clearQueue: O
    };
  }, []), Z = de(function() {
    return {
      setFileData: q,
      getFileData: K,
      removeFileData: A
    };
  }, []);
  return /* @__PURE__ */ $(ve.Provider, {
    value: {
      uploadStatus: w,
      setUploadStatus: D,
      fileEvent: P,
      fileData: Z
    },
    children: d
  });
}, Da = function() {
  var e = Y.useContext(ve), d = e.fileEvent, h = e.setUploadStatus, w = function(c) {
    h(function(b) {
      var F, H, O = Object.assign({}, b[c]);
      O.files = (O == null || (F = O.files) == null ? void 0 : F.filter(function(q) {
        return q.status === E.PROGRESS || q.status === E.QUEUED;
      })) || [];
      var R = Object.assign({}, b, (H = {}, H[c] = O, H));
      return R;
    }), d.clearQueue(c);
  };
  return {
    clearStatus: w
  };
}, Xe = ["uniqueIdentifier", "className", "retryHandler", "deleteHandler"], er = /* @__PURE__ */ G.div.withConfig({
  displayName: "fileProgress__StyledFileProgressContainer",
  componentId: "bx7y03-0"
})(["&.FileProgress--container{", ";}"], function(f) {
  var e = f.theme.components.fileUpload;
  return V(e.StyledFileProgressContainer);
}), rr = /* @__PURE__ */ G.span.withConfig({
  displayName: "fileProgress__StyledIconWrapper",
  componentId: "bx7y03-1"
})(["&.FileProgress--icon{", ";}"], function(f) {
  var e = f.theme.components.fileUpload;
  return V(e.StyledIconWrapper);
}), tr = /* @__PURE__ */ G.div.withConfig({
  displayName: "fileProgress__StyledProgressWrapper",
  componentId: "bx7y03-2"
})(["&.FileProgress-wrapper{", ";}"], function(f) {
  var e = f.theme.components.fileUpload;
  return V(e.StyledProgressWrapper);
}), fe = function(e) {
  var d = e.uniqueIdentifier, h = e.className, w = e.retryHandler, D = e.deleteHandler, c = be(e, Xe), b = he(ve), F = b.setUploadStatus, H = b.fileEvent, O = b.fileData, R = se({}), q = re(""), A = q[0], K = q[1], P = re({}), Z = P[0], U = P[1], l = ye(c.children, {
    RetryButton: fe.RetryButton,
    TrashButton: fe.TrashButton
  }, ye.PickType.LAST);
  pe(function() {
    return H.fileSubscribe(d, function(x, g) {
      g === void 0 && (g = !1), g ? U(function(r) {
        var a = Object.assign({}, r);
        return Object.keys(r).forEach(function(p) {
          var _, S;
          ((_ = a[p]) == null ? void 0 : _.status) === E.PROGRESS || ((S = a[p]) == null ? void 0 : S.status) === E.QUEUED || delete a[p];
        }), a;
      }) : ue(x, ge());
    }), function() {
      H.fileUnsubscribe(d);
    };
  }, [d]);
  var L = We(function(x, g) {
    var r, a, p = O.getFileData(d);
    return a = {}, a[g] = {
      files: (r = Object.keys(x)) == null ? void 0 : r.map(function(_) {
        var S, z, i, u = x[_];
        return u && (p != null && p.skipUpload ? {
          fileId: _,
          fileObj: u.file
        } : {
          fileId: _,
          name: u == null || (S = u.file) == null ? void 0 : S.name,
          size: u == null || (z = u.file) == null ? void 0 : z.size,
          type: u == null || (i = u.file) == null ? void 0 : i.type,
          status: u == null ? void 0 : u.status,
          errorMessage: u == null ? void 0 : u.errorMessage,
          responseObj: u == null ? void 0 : u.responseObj
        });
      }).filter(function(_) {
        return _ !== null;
      }),
      changeKey: ge()
    }, a;
  }, []), J = function(g) {
    setTimeout(function() {
      F(L(g, d));
    }, 100);
  }, ae = function(g, r, a, p, _, S, z, i) {
    if (g) {
      var u = new FormData();
      u.append(_, g), Object.keys(z).forEach(function(y) {
        u.append(y, z[y]);
      });
      var k = new XMLHttpRequest();
      k.open(p, a, !0), Object.keys(S).forEach(function(y) {
        k.setRequestHeader(y, S[y]);
      }), k.upload.onprogress = /* @__PURE__ */ function() {
        var y = ee(/* @__PURE__ */ W.mark(function T(v) {
          var m, j;
          return W.wrap(function(n) {
            for (; ; )
              switch (n.prev = n.next) {
                case 0:
                  m = Math.ceil(v.loaded / v.total * 100), j = null, U(function(o) {
                    var C, X, oe = Object.assign({}, o, (C = {}, C[r] = Object.assign({}, o[r], {
                      progress: m,
                      status: E.PROGRESS
                    }), C));
                    return ((X = o[r]) == null ? void 0 : X.status) !== E.PROGRESS && (j = Object.assign({}, oe)), oe;
                  }), j && F(L(j, d));
                case 4:
                case "end":
                  return n.stop();
              }
          }, T);
        }));
        return function(T) {
          return y.apply(this, arguments);
        };
      }(), k.onload = /* @__PURE__ */ ee(/* @__PURE__ */ W.mark(function y() {
        var T = this, v, m, j;
        return W.wrap(function(n) {
          for (; ; )
            switch (n.prev = n.next) {
              case 0:
                if (this.status >= 200 && this.status <= 299)
                  v = {}, U(function(o) {
                    var C;
                    return v = Object.assign({}, o, (C = {}, C[r] = Object.assign({}, o[r], {
                      progress: 100,
                      errorMessage: null,
                      status: E.SUCCESS,
                      responseObj: T.response
                    }), C)), J(v), v;
                  });
                else {
                  m = "Something went wrong";
                  try {
                    m = (j = JSON.parse(this.response)) == null ? void 0 : j.message;
                  } catch {
                    console.warn("Response is not a valid json");
                  }
                  U(function(o) {
                    var C, X = Object.assign({}, o, (C = {}, C[r] = Object.assign({}, o[r], {
                      progress: 100,
                      errorMessage: m,
                      status: E.ERROR,
                      responseObj: T.response
                    }), C));
                    return J(X), X;
                  });
                }
              case 1:
              case "end":
                return n.stop();
            }
        }, y, this);
      })), k.onerror = /* @__PURE__ */ ee(/* @__PURE__ */ W.mark(function y() {
        var T = this, v, m;
        return W.wrap(function(B) {
          for (; ; )
            switch (B.prev = B.next) {
              case 0:
                v = "Something went wrong", m = {}, U(function(n) {
                  var o;
                  return m = Object.assign({}, n, (o = {}, o[r] = Object.assign({}, n[r], {
                    progress: 100,
                    errorMessage: v,
                    status: E.ERROR,
                    responseObj: T.response
                  }), o)), J(m), m;
                });
              case 3:
              case "end":
                return B.stop();
            }
        }, y);
      })), k.ontimeout = /* @__PURE__ */ ee(/* @__PURE__ */ W.mark(function y() {
        var T = this, v, m;
        return W.wrap(function(B) {
          for (; ; )
            switch (B.prev = B.next) {
              case 0:
                v = "Request timed out!", m = {}, U(function(n) {
                  var o;
                  return m = Object.assign({}, n, (o = {}, o[r] = Object.assign({}, n[r], {
                    progress: 100,
                    errorMessage: v,
                    status: E.ERROR,
                    responseObj: T.response
                  }), o)), J(m), m;
                });
              case 3:
              case "end":
                return B.stop();
            }
        }, y);
      })), k.withCredentials = i, k.send(u);
    }
  }, ie = function(g) {
    var r, a;
    if ((r = Z[g]) != null && r.file) {
      var p = O.getFileData(d);
      ae((a = Z[g]) == null ? void 0 : a.file, g, p.url, p.method, p.param, p.headers, p.body, p.credentials);
    }
  }, ue = /* @__PURE__ */ function() {
    var x = ee(/* @__PURE__ */ W.mark(function g(r, a) {
      var p;
      return W.wrap(function(S) {
        for (; ; )
          switch (S.prev = S.next) {
            case 0:
              if (r) {
                S.next = 2;
                break;
              }
              return S.abrupt("return");
            case 2:
              p = O.getFileData(d), function() {
                var z = ee(/* @__PURE__ */ W.mark(function u(k) {
                  var y;
                  return W.wrap(function(v) {
                    for (; ; )
                      switch (v.prev = v.next) {
                        case 0:
                          y = {}, U(function(m) {
                            var j;
                            return y = Object.assign({}, m, (j = {}, j[k] = {
                              file: r,
                              progress: 0,
                              status: p.skipUpload ? E.IDLE : E.QUEUED,
                              errorMessage: null
                            }, j)), J(y), y;
                          }), p.skipUpload || ae(r, k, p.url, p.method, p.param, p.headers, p.body, p.credentials);
                        case 3:
                        case "end":
                          return v.stop();
                      }
                  }, u);
                }));
                function i(u) {
                  return z.apply(this, arguments);
                }
                return i;
              }()(a);
            case 4:
            case "end":
              return S.stop();
          }
      }, g);
    }));
    return function(r, a) {
      return x.apply(this, arguments);
    };
  }(), ne = /* @__PURE__ */ function() {
    var x = ee(/* @__PURE__ */ W.mark(function g(r) {
      var a;
      return W.wrap(function(_) {
        for (; ; )
          switch (_.prev = _.next) {
            case 0:
              if (r) {
                _.next = 2;
                break;
              }
              return _.abrupt("return");
            case 2:
              a = Object.assign({}, Z), a[r] && (a[r] = null, delete a[r]), R.current && R.current[r] && R.current[r] && (R.current[r] = null, delete R.current[r]), U(a), J(a);
            case 7:
            case "end":
              return _.stop();
          }
      }, g);
    }));
    return function(r) {
      return x.apply(this, arguments);
    };
  }(), le = de(function() {
    var x, g = O.getFileData(d), r = (x = Object.keys(Z)) == null ? void 0 : x.map(function(a) {
      var p, _, S, z;
      if (!a)
        return null;
      var i = Z[a];
      if (!i)
        return null;
      var u = Ye("" + (i == null || (p = i.file) == null ? void 0 : p.size)), k = ((i == null || (_ = i.file) == null ? void 0 : _.name) || "") + " (" + u + ")", y = i.status === E.SUCCESS ? "success" : i.status === E.ERROR ? "error" : "default", T = y === "error" ? i.errorMessage : "", v = function() {
        if (R.current) {
          var n = R.current[a], o = i.status === E.QUEUED ? "Queued" : i.status === E.PROGRESS ? i.progress + "%" : "", C = i.progress + "_" + y + "_" + i.errorMessage;
          return (!n || n && n.compareKey !== C) && (n = {
            compareKey: C,
            progressBar: g.skipUpload ? /* @__PURE__ */ $(Se, {
              labelProp: {
                label: k
              },
              trailingText: "Ready"
            }) : /* @__PURE__ */ $(ze, {
              "aria-valuetext": i.status === "default" ? "progressing" : i.status,
              "aria-valuenow": i.progress,
              "aria-busy": !["success", "error"].includes((i == null ? void 0 : i.status) || ""),
              labelProp: {
                label: k
              },
              max: 100,
              value: i.progress,
              status: y,
              helperTextProp: {
                defaultProp: {
                  helperText: T ?? ""
                }
              },
              trailingText: o
            }, ge())
          }, R.current[a] = n), n.progressBar;
        }
      }, m = g.skipUpload ? !1 : i.status !== E.SUCCESS && i.status !== E.ERROR, j = i.status === E.ERROR;
      return /* @__PURE__ */ te(tr, {
        className: Q(["FileProgress-wrapper"]),
        children: [v(), /* @__PURE__ */ te(rr, {
          className: Q(["FileProgress--icon"]),
          children: [j && /* @__PURE__ */ $(ce, Object.assign({
            color: "black",
            variant: "tertiary",
            icon: "undo",
            size: "large",
            "aria-label": "retry"
          }, (S = l.RetryButton) == null ? void 0 : S.props, {
            onKeyDown: function(n) {
              var o;
              (o = l.RetryButton) == null || o.props.onKeyDown == null || o.props.onKeyDown(n), (n.code === "Enter" || n.code === "Space") && (ie(a), w && w(n, Object.assign({}, i, {
                fileId: a
              })));
            },
            onClick: function(n) {
              var o;
              (o = l.RetryButton) == null || o.props.onClick == null || o.props.onClick(n), ie(a), w && w(n, Object.assign({}, i, {
                fileId: a
              }));
            }
          })), /* @__PURE__ */ $(ce, Object.assign({
            icon: "delete",
            variant: "tertiary",
            color: "black",
            "aria-label": "trash",
            disabled: m,
            size: "large",
            className: Q({
              disabled: m
            })
          }, (z = l.TrashButton) == null ? void 0 : z.props, {
            onKeyDown: function(n) {
              var o;
              if ((o = l.TrashButton) == null || o.props.onKeyDown == null || o.props.onKeyDown(n), (n.code === "Enter" || n.code === "Space") && !m) {
                var C;
                ne(a), K("File " + (i == null || (C = i.file) == null ? void 0 : C.name) + " deleted successfully"), D && D(n, Object.assign({}, i, {
                  fileId: a
                }));
              }
            },
            onClick: function(n) {
              var o;
              if ((o = l.TrashButton) == null || o.props.onClick == null || o.props.onClick(n), !m) {
                var C;
                ne(a), K("File " + (i == null || (C = i.file) == null ? void 0 : C.name) + " deleted successfully"), D && D(n, Object.assign({}, i, {
                  fileId: a
                }));
              }
            }
          }))]
        })]
      }, a);
    });
    return r;
  }, [Z]);
  return /* @__PURE__ */ te(Ke, {
    children: [le.length > 0 ? /* @__PURE__ */ $(er, {
      className: Q("FileProgress--container", h),
      "data-testid": "file-progress-bar-" + d,
      "aria-label": d + "-progress-bar",
      children: le.map(function(x) {
        return x;
      })
    }) : null, /* @__PURE__ */ $(Fe, {
      "aria-live": "assertive",
      children: A
    })]
  });
};
fe.RetryButton = function(f) {
  return /* @__PURE__ */ $(ce, Object.assign({}, f));
};
fe.TrashButton = function(f) {
  return /* @__PURE__ */ $(ce, Object.assign({}, f));
};
var ar = ["buttonLabel", "onClick", "_disabled", "className", "accessibilityOptions", "icon"], ir = ["iconName", "children", "_onClick", "_handleDrop", "_disabled", "className", "accessibilityOptions"], nr = /* @__PURE__ */ G.div.withConfig({
  displayName: "fileupload__StyledFileUploadContainer",
  componentId: "sc-1lqy739-0"
})(["&.FileUpload--container{", ";}"], function(f) {
  var e = f.theme.components.fileUpload;
  return V(e.StyledFileUploadContainer);
}), lr = /* @__PURE__ */ G.div.withConfig({
  displayName: "fileupload__StyledFileHeader",
  componentId: "sc-1lqy739-1"
})(["&.FileUpload--header{", ";}"], function(f) {
  var e = f.theme.components.fileUpload;
  return V(e.StyledFileHeader);
}), or = /* @__PURE__ */ G.p.withConfig({
  displayName: "fileupload__StyledFileHeaderHelperText",
  componentId: "sc-1lqy739-2"
})(["&.FileUpload--header-helperText{", ";}"], function(f) {
  var e = f.theme.components.fileUpload;
  return V(e.StyledFileHeaderHelperText);
}), sr = /* @__PURE__ */ G.div.withConfig({
  displayName: "fileupload__StyledDropZoneWrapper",
  componentId: "sc-1lqy739-3"
})(["&.FileUpload--dropZoneWrapper{", ";}"], function(f) {
  var e = f.theme.components.fileUpload;
  return V(e.StyledDropZoneWrapper);
}), Ue = /* @__PURE__ */ G.div.withConfig({
  displayName: "fileupload__AlertWrapper",
  componentId: "sc-1lqy739-4"
})([""]), ur = /* @__PURE__ */ G.div.withConfig({
  displayName: "fileupload__StyledDropZoneIconWrapper",
  componentId: "sc-1lqy739-5"
})(["&.FileUpload--dropZoneIcon{", ";}"], function(f) {
  var e = f.theme.components.fileUpload;
  return V(e.StyledDropZoneIconWrapper);
}), pr = /* @__PURE__ */ G.p.withConfig({
  displayName: "fileupload__StyledDropzoneTextwrapper",
  componentId: "sc-1lqy739-6"
})(["&.FileUpload--dropZoneTextwrapper{", ";}"], function(f) {
  var e = f.theme.components.fileUpload;
  return V(e.StyledDropzoneTextwrapper);
}), _e = function(e) {
  var d = e.helperText, h = e.className, w = e.labelProp, D = e.infoProp, c = e.trailingText;
  return /* @__PURE__ */ te(lr, {
    className: Q(["FileUpload--header", h]),
    children: [/* @__PURE__ */ $(Se, {
      labelProp: Object.assign({
        showRequiredIndicator: !1
      }, w),
      infoProp: Object.assign({
        infoText: "",
        infoType: "tooltip",
        popupTipHeader: "Info"
      }, D),
      trailingText: c
    }), d && /* @__PURE__ */ $(or, {
      className: Q(["FileUpload--header-helperText"]),
      children: d
    })]
  });
}, Ce = function(e) {
  var d = e.buttonLabel, h = d === void 0 ? "Choose Files To Upload" : d, w = e.onClick, D = e._disabled, c = D === void 0 ? !1 : D, b = e.className, F = e.accessibilityOptions, H = F === void 0 ? {} : F, O = e.icon, R = be(e, ar), q = Ae(), A = q.width, K = Oe("button", Object.assign({}, H, {
    ariaDisabled: c
  }));
  return /* @__PURE__ */ $(Qe, Object.assign({
    size: A > Ze.tabletMin ? "medium" : "small",
    fullWidthMobile: !1,
    variant: "secondary",
    color: "default",
    className: "btn " + b,
    onClick: w,
    tabIndex: c ? -1 : 0,
    disabled: c,
    leftIcon: O == null ? void 0 : O.leadingIcon,
    rightIcon: O == null ? void 0 : O.trailingIcon
  }, K, R, {
    children: h
  }));
}, De = function(e) {
  var d = e.iconName, h = d === void 0 ? "cloud" : d, w = e.children, D = e._onClick, c = e._handleDrop, b = e._disabled, F = b === void 0 ? !1 : b, H = e.className, O = e.accessibilityOptions, R = O === void 0 ? {
    ariaLabel: "Browse or drag files here"
  } : O, q = be(e, ir), A = Oe("button", Object.assign({}, R, {
    ariaDisabled: F
  })), K = function(l) {
    l.preventDefault();
  }, P = function(l) {
    (l.code === "Enter" || l.code === "Space") && D && !F && D();
  }, Z = function(l) {
    return !F && c && c(l);
  };
  return /* @__PURE__ */ te(sr, Object.assign({
    onDragOver: K,
    onDrop: Z,
    onKeyDown: P,
    className: Q(["FileUpload--dropZoneWrapper", H, {
      "FileUpload--dropZoneWrapper--disabled": F
    }])
  }, A, {
    role: "button",
    tabIndex: F ? -1 : 0
  }, q, {
    children: [/* @__PURE__ */ $(ur, {
      className: Q(["FileUpload--dropZoneIcon", {
        "FileUpload--dropZoneIcon--disabled": F
      }]),
      children: h && /* @__PURE__ */ $(Ge, {
        icon: h
      })
    }), /* @__PURE__ */ $(pr, {
      className: Q(["FileUpload--dropZoneTextwrapper", {
        "FileUpload--dropZoneTextwrapper--disabled": F
      }]),
      onClick: function() {
        return D && !F && D();
      },
      children: w
    })]
  }));
}, me = function(e) {
  var d = e.maxFilesCount, h = d === void 0 ? 10 : d, w = e.maxFileSize, D = e.allowedFileType, c = e.disabled, b = c === void 0 ? !1 : c, F = e.className, H = F === void 0 ? "" : F, O = e.fileUploadUrl, R = O === void 0 ? "" : O, q = e.uploadMethod, A = q === void 0 ? "POST" : q, K = e.uniqueIdentifier, P = K === void 0 ? "" : K, Z = e.skipUpload, U = Z === void 0 ? !1 : Z, l = e.uploadParamName, L = l === void 0 ? "file" : l, J = e.children, ae = e.filesHeaders, ie = ae === void 0 ? {} : ae, ue = e.withCredentials, ne = ue === void 0 ? !1 : ue, le = e.requestBody, x = le === void 0 ? {} : le, g = e.alertMessages, r = g === void 0 ? {
    invalidFile: "Please provide valid file types.",
    maxSize: "Files can be up to"
  } : g, a = e.uploadStatusCallback, p = e.fileValidator, _ = Le({
    label: "FileUpload"
  }), S = se(null), z = se(null), i = re([]), u = i[0], k = i[1], y = re(null), T = y[0], v = y[1], m = he(ve), j = m.uploadStatus, B = m.fileEvent, n = m.fileData, o = re(""), C = o[0], X = o[1], oe = re(""), je = oe[0], we = oe[1];
  pe(function() {
    j[P] && j[P].changeKey !== C && (X(j[P].changeKey), a && a(j[P].files));
  }, [j]), pe(function() {
    var M = {
      url: R,
      method: A,
      param: L,
      headers: ie,
      credentials: ne,
      skipUpload: U,
      body: x
    };
    return n.setFileData(P, M), function() {
      n.removeFileData(P);
    };
  }, [R, P, A, L, ne, ie, n, U]);
  var Re = function(s) {
    var t = s - h;
    v((r == null ? void 0 : r.maxFileCount) || "You can upload up to " + h + " files. Remove " + t + " file(s).");
  }, Ee = function(s) {
    var t = !0;
    if (w && w * 1e3 * 1e3 < s.size && (v(((r == null ? void 0 : r.maxSize) || "Files can be up to") + " " + w + "MB."), t = !1), p) {
      var N = p(s);
      typeof N == "object" && N.valid === !1 ? (v(N.message || (r == null ? void 0 : r.invalidFile) || "Please provide valid file types."), t = !1) : typeof N == "boolean" && N === !1 && (v((r == null ? void 0 : r.invalidFile) || "Please provide valid file types."), t = !1);
    } else
      D && D.length > 0 && !D.includes(s.type) && (v((r == null ? void 0 : r.invalidFile) || "Please provide valid file types."), t = !1);
    return t;
  }, $e = function(s) {
    var t = u.length, N = !0;
    t > 0 && (t > h ? (Re(t), N = !1) : s == null || s.forEach(function(I) {
      I && (N = N && Ee(I));
    })), N && (s == null || s.forEach(function(I) {
      I && B.fileDispatch(P, I);
    }));
  };
  pe(function() {
    var M;
    if ($e(u), u.length) {
      var s = u.length === 1 ? u[0].name + "  Selected" : u.length + " files Selected";
      we(s);
    }
    (M = z.current) == null || M.reset();
  }, [u]);
  var xe = function(s) {
    var t;
    if (s != null && (t = s.target) != null && t.files) {
      var N = Array.from(s.target.files).filter(function(I) {
        return !!I;
      });
      k(N);
    }
  }, Pe = function(s) {
    s.preventDefault(), v(null), k(Array.from(s.dataTransfer.files));
  }, ke = de(function() {
    return T ? /* @__PURE__ */ $(Ve, {
      variant: "error",
      body: T
    }) : null;
  }, [T]), Te = function(s, t) {
    return /* @__PURE__ */ Y.cloneElement(s, Object.assign({}, {
      // Adding callback for file upload input change
      onClick: function() {
        var I;
        S == null || (I = S.current) == null || I.click(), t.onClick && t.onClick();
      },
      _disabled: b
    }));
  }, Be = function(s, t) {
    return /* @__PURE__ */ Y.cloneElement(s, Object.assign({}, {
      _onClick: function() {
        var I;
        S == null || (I = S.current) == null || I.click(), t._onClick && t._onClick();
      },
      // Adding callback for file upload drop event
      _handleDrop: Pe,
      _disabled: b
    }));
  }, Ne = function(s, t) {
    return /* @__PURE__ */ Y.cloneElement(s, Object.assign({}, {
      helperText: t
    }));
  }, Me = function(s) {
    return s != null && s.helperText ? (s == null ? void 0 : s.helperText) === "DEFAULT" ? "Upload up to " + h + " files. " + (w ? "Files can be up to " + w + "MB." : "") : s == null ? void 0 : s.helperText : null;
  }, Ie = function(s) {
    return Y.Children.map(s, function(t) {
      if (t && /* @__PURE__ */ Y.isValidElement(t))
        if ((t == null ? void 0 : t.type) === Ce) {
          var N = t == null ? void 0 : t.props;
          return Te(t, N);
        } else if ((t == null ? void 0 : t.type) === De) {
          var I = t == null ? void 0 : t.props;
          return Be(t, I);
        } else {
          if ((t == null ? void 0 : t.type) === Ue)
            return ke;
          if ((t == null ? void 0 : t.type) === _e) {
            var He = t == null ? void 0 : t.props, qe = Me(He);
            return Ne(t, qe);
          }
        }
      return t;
    });
  };
  return /* @__PURE__ */ te(nr, Object.assign({
    className: Q("FileUpload--container", H)
  }, _, {
    children: [Ie(J), /* @__PURE__ */ $("form", {
      ref: z,
      children: /* @__PURE__ */ $("input", {
        id: P,
        ref: S,
        "data-testid": "file-input-" + P,
        type: "file",
        multiple: !0,
        hidden: !0,
        onChange: function(s) {
          xe(s), v(null);
        }
      })
    }), /* @__PURE__ */ $(Fe, {
      "aria-live": "assertive",
      children: !!u.length && je
    })]
  }));
};
me.Button = Ce;
me.DropZone = De;
me.Alert = Ue;
me.Header = _e;
export {
  fe as FileProgress,
  me as FileUpload,
  Ca as FileUploadProvider,
  E as UPLOAD_STATUS,
  Da as useFileUploadContext
};
